import { getExport, setExport, inquiryExport } from '@/services/inqueryServices'

const state = {
  exportFormData: {},
  exportResult: [],
  exportExcelData: []
}

const getters = {}

const mutations = {
  GET_EXPORT (state, data) {
    state.exportFormData = data.allconfig
    state.exportResult = data.config
  },
  UPDATE_RESULT (state, data) {
    state.exportResult = data
  },
  SET_EXPORT_EXCEL_DATA (state, data) {
    state.exportExcelData = data
  }
}

const actions = {
  async fetchExportConfig ({ commit }) {
    const chain = await getExport().onSuccess(async payload => {
      commit('GET_EXPORT', payload)
    })
    return chain
  },

  async setExportConfig ({ commit, dispatch }) {
    const chain = await setExport()
    return chain
  },

  async fetchExportExcelData ({ state, commit }) {
    const chain = await inquiryExport().onSuccess(async payload => {
      // console.log(payload)
      commit('SET_EXPORT_EXCEL_DATA', payload)
    })
    return chain
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
